import { useState, useEffect } from 'react';

const useAccessToken = () => {
    const [accessToken, setAccessToken] = useState(sessionStorage.getItem('access_token') || '');

    useEffect(() => {
        const handleAccessTokenChange = () => {
            setAccessToken(sessionStorage.getItem('access_token') || '');
        };
        const handleRemoveAccessToken = () => {
            sessionStorage.removeItem('access_token');
            window.location.href = '/';
        };

        window.addEventListener('accessTokenChanged', handleAccessTokenChange);
        window.addEventListener('removeAccessToken', handleRemoveAccessToken);

        return () => {
            window.removeEventListener('accessTokenChanged', handleAccessTokenChange);
            window.removeEventListener('removeAccessToken', handleRemoveAccessToken);
        };
    }, []);

    return accessToken;
};

export default useAccessToken;
